import React, { useState } from "react";
import ImageProcessor from "./components/ImageProcessor.jsx";
import WebcamCapture from "./components/WebcamCapture.jsx";
import "./App.css";

const App = () => {
  const [imageSrc, setImageSrc] = useState(null);

  return (
    <div className="app">
      <h1>My alter-ego is required fields on the internet</h1>
      <WebcamCapture onCapture={setImageSrc} captureInterval={50} />{" "}
      {imageSrc && <ImageProcessor rows={50} imageSrc={imageSrc} />}
    </div>
  );
};

export default App;
